import { FormikSelect } from "../../../../../components/widgets";


const hourRatingOptions = [
'-',
'1',
'1.5',
'2',
'4',
];


type Props = {
  size?: string
  label?: string
  name?: string
  required?: boolean
  readOnly?: boolean
}

export const DOCHourRatingDropdown = ({ size = '6', label = 'Hour Rating', name = "hourRating", required, readOnly} : Props) => {

  
  return (
    <FormikSelect 
      size={size} 
      label={label} 
      name={name} 
      options={hourRatingOptions.map(str => ({value: str, text: str}))} 
      required={required} 
      readOnly={readOnly}
      title="If no hour rating, select '-'."
    />
                
  )
}